import React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { useTranslation } from 'react-i18next';

export interface NavDrawerItem {
    key: string;
    label: string;
    onClick?: () => void;
    disabled?: boolean;
}

interface MobileNavDrawerProps {
    open: boolean;
    onClose: () => void;
    header?: React.ReactNode;
    items: NavDrawerItem[];
}

// The one mobile navigation surface shared by the public site (Nav.tsx) and
// the authenticated app (ActivitiesBar.tsx) -- previously each had its own,
// visually and behaviorally different, mobile menu.
function MobileNavDrawer({ open, onClose, header, items }: MobileNavDrawerProps) {
    const { t } = useTranslation();

    return (
        <Drawer anchor="left" open={open} onClose={onClose}>
            <Box sx={{ width: 280 }} role="presentation">
                {header}
                <List>
                    {items.map((item) => (
                        <ListItemButton
                            key={item.key}
                            disabled={item.disabled}
                            onClick={() => {
                                item.onClick?.();
                                onClose();
                            }}
                        >
                            <ListItemText
                                primary={item.label}
                                secondary={item.disabled ? t('common.comingSoon') : undefined}
                            />
                        </ListItemButton>
                    ))}
                </List>
            </Box>
        </Drawer>
    );
}

export default MobileNavDrawer;
